import { render, staticRenderFns } from "./LandingPanel.vue?vue&type=template&id=5374f744"
import script from "./LandingPanel.vue?vue&type=script&lang=js"
export * from "./LandingPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports